import { Component, inject, Input } from '@angular/core';
import { UnitTypes } from '@shared/enums/UnitTypes.enum';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ContractService
} from '@modules/universal-billing/residents/resident-profile/compoents/contract/contract.service';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { UtilityProvidersService } from '@modules/settings/utility-providers/utility-providers.service';
import { MetersService } from '@modules/settings/meters/meters.service';
import { TariffsService } from '@modules/settings/tariffs/tariffs.service';
import { UtilityRatesService } from '@modules/settings/utility-rates/utility-rates.service';
import { InputNumberModule } from '@primeng/inputnumber';
import { CalendarModule } from '@primeng/calendar';
import { formatDate } from '@shared/utils/format-date';
import {DatepickerComponent} from '@shared/components/datepicker/datepicker.component';

@Component({
  selector: 'app-contract',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputValidatorDirective,
    TranslatePipe,
    AutocompleteComponent,
    InputNumberModule,
    CalendarModule,
    DatepickerComponent
  ],
  templateUrl: './contract.component.html',
  styleUrl: './contract.component.scss'
})
export class ContractComponent extends BasicForm<any> {
  @Input() type: UnitTypes;
  @Input() residentId: number;
  _defaultService: ContractService = inject(ContractService);
  form: FormGroup;
  providerService = inject(UtilityProvidersService);
  meterService = inject(MetersService);
  tariffService = inject(TariffsService);
  utilityRateService = inject(UtilityRatesService);
  dateFields = ['startDate', 'endDate', 'terminatedAt'];

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      residentId: [null, [Validators.required]],
      providerId: [null, [Validators.required]],
      meterId: [null, [Validators.required]],
      tariffId: [null, [Validators.required]],
      utilityRateId: [null, [Validators.required]],
      taxRatePercent: [null, [Validators.required, Validators.min(0)]],
      taxRateAmount: [null, [Validators.required, Validators.min(0)]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      terminatedAt: [''],
      number: ['', [Validators.required]],
      status: [true, [Validators.required]]
    })
  }
  ngOnInit() {
    this.form.patchValue({
      residentId: this.residentId,
    })
    super.ngOnInit();
  }

}
